import React from 'react'
export default ({ title, children }) => (
	<svg
		width="64px"
		height="64px"
		version="1.1"
		aria-labelledby="title"
		xmlns="http://www.w3.org/2000/svg">
		<title>{title}</title>
		{children}
	</svg>
)
